import { fromEvent, merge, Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { mapTo } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StatusCheckService {
  constructor() {}

  readonly online$: Observable<boolean> = merge(
    of(navigator.onLine),
    fromEvent(window, 'online').pipe(mapTo(true)),
    fromEvent(window, 'offline').pipe(mapTo(false))
  );
}
